import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'
import VueBarcode from 'vue-barcode';
import pdfMake from "pdfmake/build/pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  name: 'ebn-copy',
  components: {
    VueElementLoading,
    'barcode': VueBarcode,
    'qr-code':VueQRCodeComponent
  },
  props: ['selectedData'],
  data: function() {
    return {
      PrintAWBModal: false,
      ebnData: JSON.parse(JSON.stringify(this.selectedData)),
      hsncode:'',
      isextended:'',
      transactiontype:'',
      supplytype:'',
      subsupplytype:'',
      ebn:''
    }
  },
  computed: {},
  mounted () {
    let hsnarray = []
    this.ebn = this.ebnData.details.ewbNo.toString()
    this.isextended = this.ebnData.details.extendedTimes == 0 ? 'Unextended':extended
    this.transactiontype = (this.ebnData.details.transactionType == 1)?'Regular':(this.ebnData.details.transactionType == 2)?'Bill To - Ship To':(this.ebnData.details.transactionType == 3)?'Bill From - Dispatch From':'Combination of 2 and 3'
    this.supplytype = (this.ebnData.details.supplyType == "o")?'Outward':'Inward'
    this.subsupplytype = (this.ebnData.details.subSupplyType == "1")?'Supply':(this.ebnData.details.subSupplyType == "2")?'Import':(this.ebnData.details.subSupplyType == "3")?'Export':(this.ebnData.details.subSupplyType == "4")?'Job Work':(this.ebnData.details.subSupplyType == "5")?'For Own Use':(this.ebnData.details.subSupplyType == "6")?'Job work Returns':(this.ebnData.details.subSupplyType == "7")?'Sales Return':(this.ebnData.details.subSupplyType == "8")?'Others':(this.ebnData.details.subSupplyType == "9")?'SKD/CKD/Lots':(this.ebnData.details.subSupplyType == "10")?'Line Sales':(this.ebnData.details.subSupplyType == "11")?'Recipient Not Known':'Exhibition or Fairs'
    this.ebnData.details.itemList.forEach(el=>{
      hsnarray.push(el.hsnCode)
    })
    this.hsncode = hsnarray.join(", ")
  },
  methods: {
    closePrintAWBModal(){
       this.PrintAWBModal = false;
    },
    DownloadEBN(){
      const contentHtml = document.getElementById('printebnData').innerHTML;
      var html = htmlToPdfmake(contentHtml);
      var docDefinition = {
       content: [
         html
       ],
       styles:{
         'with-margin':{
           marginLeft: 30 // apply a margin with the specific class is used
         }
       }
      };
      pdfMake.createPdf(docDefinition).download();
    },
    async PrintEBN() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 1;
    border-top: 1px solid #c2cfd6;
}
           table {
               border-collapse: collapse;
               margin-left:10px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           header {
             font-size: 9px;
             color: #000;
             text-align: left;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          h3 {
          page-break-after: always;
          }
          }
          `
      d.print(document.getElementById('printebnData'), cssText);
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/EbnDetails/EbnDetails.component.js